import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import Styled from './styles';


export interface LegendProps extends React.ComponentPropsWithRef<'div'> {
  /** The content of the Legend */
  children: React.ReactNode;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** All props will be provided to the root element (`legend` native element). */
const Legend = React.forwardRef<HTMLElement, LegendProps>((props: LegendProps, ref) => getContext(({ RTL, theme }) => {
  const {
    children,
    theme: themeProp,
    ...wrapperProps
  } = props;
  const resolvedTheme = _merge({}, theme.LEGEND, themeProp);
  return (
    <Styled.Legend
      $theme={resolvedTheme}
      ref={ref}
      RTL={RTL}
      {...wrapperProps}
    >
      {children}
    </Styled.Legend>
  );
}));

Legend.displayName = 'Legend';

Legend.defaultProps = {
  theme: {}
};

export default Legend;
